module.exports = __webpack_public_path__ + "static/assets/fontisto_language.svg";